module.exports = __webpack_public_path__ + "static/media/metakinisi6.2eccc72c.jpg";